/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type BottomBar_navigation$ref = any;
type BottomBar_viewer$ref = any;
type MessageBanner_user$ref = any;
type MessageBanner_viewer$ref = any;
type TopBar_user$ref = any;
type TopBar_viewer$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmSalesTier = "P_AND_M" | "TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "UNKNOWN" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Header_viewer$ref: FragmentReference;
export type Header_viewer = {|
  +navigation?: ?{|
    +$fragmentRefs: BottomBar_navigation$ref
  |},
  +tradeNavigation?: ?{|
    +modules: ?$ReadOnlyArray<?{|
      +serviceId: ?string
    |}>,
    +$fragmentRefs: BottomBar_navigation$ref,
  |},
  +submittedTransactions?: ?{|
    +totalResults: ?number
  |},
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number
  |},
  +vipChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string
    |}>
  |}>,
  +tradeChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string
    |}>
  |}>,
  +allTransactions?: ?{|
    +totalResults: ?number
  |},
  +initiatedTransactions?: ?{|
    +totalResults: ?number
  |},
  +confirmedTransactions?: ?{|
    +totalResults: ?number
  |},
  +user?: ?{|
    +createdDate: ?string,
    +firstSessionDate: ?string,
    +isTrade: ?boolean,
    +hasVipPermission: ?boolean,
    +authMetadata: ?{|
      +emailOnly: ?boolean,
      +hasPassword: ?boolean,
    |},
    +profile: ?{|
      +email: ?string,
      +zipCode: ?string,
      +currency: ?Currency,
      +firstName: ?string,
      +lastName: ?string,
    |},
    +serviceId: ?string,
    +totalMessagesToDealers: ?number,
    +tradeFirm: ?{|
      +serviceId: ?string,
      +tier: ?TradeFirmSalesTier,
      +profileStatus: ?DesignProfileStatus,
      +rewards: ?{|
        +currentProgram: ?{|
          +programInfo: ?{|
            +code: ?string
          |}
        |}
      |},
    |},
    +verifiedTradeStatus: ?string,
    +roles: ?{|
      +roleList: ?$ReadOnlyArray<?{|
        +name: ?string,
        +createdDate: ?string,
        +userData: ?{|
          +userStatus: ?{|
            +name: ?string
          |}
        |},
      |}>
    |},
    +isVip: ?boolean,
    +isVerifiedTrade: ?boolean,
    +$fragmentRefs: MessageBanner_user$ref & TopBar_user$ref,
  |},
  +regionalInfo?: ?$ReadOnlyArray<?{|
    +zipCode: ?string,
    +incomeLevel: ?{|
      +incomeBracket: ?string,
      +incomePercentile: ?string,
    |},
    +currency: ?string,
  |}>,
  +$fragmentRefs: TopBar_viewer$ref & BottomBar_viewer$ref & MessageBanner_viewer$ref,
  +$refType: Header_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "zipCode",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds",
  "type": "[String]"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 0,
  "type": "Int"
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
],
v5 = {
  "kind": "Literal",
  "name": "viewName",
  "value": "buyerTracking.confirmed",
  "type": "String"
},
v6 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]!"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey",
  "type": "String"
},
v13 = {
  "kind": "FragmentSpread",
  "name": "BottomBar_navigation",
  "args": null
};
return {
  "kind": "Fragment",
  "name": "Header_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "previewKey",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchNav",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchTradeNav",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "showMarketingMessages",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    },
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TopBar_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BottomBar_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "incomeLevel",
              "storageKey": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "zipCode",
                  "variableName": "zipCode",
                  "type": "String"
                }
              ],
              "concreteType": "IncomeLevel",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "incomeBracket",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "incomePercentile",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            (v1/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "showMarketingMessages",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "MessageBanner_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.submitted",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v5/*: any*/)
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "vipChatEmail",
          "name": "userRelationships",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            },
            (v6/*: any*/)
          ],
          "concreteType": "UserRelationship",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "userDataB",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "VipRepData",
                  "selections": (v8/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "tradeChatEmail",
          "name": "userRelationships",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "TRADE",
              "type": "relationshipType!"
            },
            (v6/*: any*/)
          ],
          "concreteType": "UserRelationship",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "userDataB",
              "storageKey": null,
              "args": null,
              "concreteType": null,
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "TradeRepData",
                  "selections": (v8/*: any*/)
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "viewName",
              "value": "buyerTracking.initiated",
              "type": "String"
            }
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "confirmedTransactions",
          "name": "transactions",
          "storageKey": null,
          "args": [
            (v2/*: any*/),
            (v3/*: any*/),
            {
              "kind": "Literal",
              "name": "sort",
              "value": "createdDate asc",
              "type": "String"
            },
            (v5/*: any*/)
          ],
          "concreteType": "TransactionConnection",
          "plural": false,
          "selections": (v4/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "totalMessagesToDealers",
              "args": null,
              "storageKey": null
            },
            (v9/*: any*/),
            {
              "kind": "ScalarField",
              "alias": "isTrade",
              "name": "hasPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "B_VERIFIED_TRADE",
                  "type": "String!"
                }
              ],
              "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
            },
            {
              "kind": "ScalarField",
              "alias": "hasVipPermission",
              "name": "hasPermission",
              "args": [
                {
                  "kind": "Literal",
                  "name": "name",
                  "value": "B_VIP_CHECKOUT",
                  "type": "String!"
                }
              ],
              "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "authMetadata",
              "storageKey": null,
              "args": null,
              "concreteType": "UserExistsMetadataType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "emailOnly",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "hasPassword",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "profile",
              "storageKey": null,
              "args": null,
              "concreteType": "Profile",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "firstName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastName",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            (v10/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "firstSessionDate",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "tradeFirm",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmType",
              "plural": false,
              "selections": [
                (v10/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "tier",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "profileStatus",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "rewards",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TradeFirmRewards",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "currentProgram",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ParentProgram",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "programInfo",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "LoyaltyProgram",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "code",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "verifiedTradeStatus",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "roles",
              "storageKey": null,
              "args": null,
              "concreteType": "UserRoles",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "roleList",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Role",
                  "plural": true,
                  "selections": [
                    (v11/*: any*/),
                    (v9/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "userData",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserRoleData",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "userStatus",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserRoleUserData",
                          "plural": false,
                          "selections": [
                            (v11/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isVip",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "TopBar_user",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isVerifiedTrade",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "showMarketingMessages",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "MessageBanner_user",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchTradeNav",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "tradeNavigation",
          "name": "navigation",
          "storageKey": null,
          "args": [
            (v12/*: any*/),
            {
              "kind": "Literal",
              "name": "userType",
              "value": "TRADE",
              "type": "globalNavigationuserType"
            }
          ],
          "concreteType": "Navigation",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "modules",
              "storageKey": null,
              "args": null,
              "concreteType": "NavigationModule",
              "plural": true,
              "selections": [
                (v10/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchNav",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "navigation",
          "name": "navigation",
          "storageKey": null,
          "args": [
            (v12/*: any*/)
          ],
          "concreteType": "Navigation",
          "plural": false,
          "selections": [
            (v13/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f99a8a33b2ebbdce0a93aa4186b920d6';
module.exports = node;
